import { fetchApi } from '@/services/api-client';

export interface CafeteriaCategory {
  id: string;
  name: string;
  sortOrder: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CafeteriaProduct {
  id: string;
  name: string;
  categoryId: string;
  price: number;
  active: boolean;
  sortOrder: number;
  imageUrl: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCategoryInput {
  name: string;
  sortOrder?: number;
  active?: boolean;
}
export type UpdateCategoryInput = Partial<CreateCategoryInput>;

export interface CreateProductInput {
  name: string;
  categoryId: string;
  price: number;
  sortOrder?: number;
  active?: boolean;
  imageUrl?: string;
}
export type UpdateProductInput = Partial<CreateProductInput>;

const BASE = '/admin/cafeteria';

export const cafeteriaApi = {
  listCategories: () => fetchApi<CafeteriaCategory[]>(`${BASE}/categories`),
  createCategory: (input: CreateCategoryInput) =>
    fetchApi<CafeteriaCategory>(`${BASE}/categories`, { method: 'POST', body: JSON.stringify(input) }),
  updateCategory: (id: string, input: UpdateCategoryInput) =>
    fetchApi<CafeteriaCategory>(`${BASE}/categories/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  deleteCategory: (id: string) => fetchApi<{ success: boolean }>(`${BASE}/categories/${id}`, { method: 'DELETE' }),

  listProducts: (categoryId?: string) =>
    fetchApi<CafeteriaProduct[]>(
      `${BASE}/products${categoryId ? `?categoryId=${encodeURIComponent(categoryId)}` : ''}`
    ),
  createProduct: (input: CreateProductInput) =>
    fetchApi<CafeteriaProduct>(`${BASE}/products`, { method: 'POST', body: JSON.stringify(input) }),
  updateProduct: (id: string, input: UpdateProductInput) =>
    fetchApi<CafeteriaProduct>(`${BASE}/products/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  deleteProduct: (id: string) => fetchApi<{ success: boolean }>(`${BASE}/products/${id}`, { method: 'DELETE' }),
};
